import * as NGL from 'ngl/dist/ngl.js'

function makeRepresentationsSet() {
  return {
    _pqrs: [],
    toggle(index, force = null) {
      const pqr = this._pqrs[index];
      if (!pqr) return;
      if (force === null) {
        pqr.toggleVisibility();
      } else {
        pqr.setVisibility(force);
      }
    },
    addPqr(index, pqr) {
      this._pqrs.push(pqr.addRepresentation("surface", {
        color: cavidb.palette.slice(1)[index],
        opacity: 0.6,
        wireframe: true
      }));
      this.toggle(index);
    },
    clear() {
      this._pqrs = [];
    }
  };
}

function initViewer(elementId, containerClass, chain, representationsSet) {
  representationsSet.clear();
  if (!chain) return;

  const $root = $(`#${elementId}`);
  const $container = $(`.${containerClass}`);
  if ($root.length === 0) return;

  const stage = new NGL.Stage(elementId, { backgroundColor: 'white' });

  window.addEventListener('wheel', function (event) {
    if ($root[0].contains(event.target)) {
      event.preventDefault();
    }
  }, { passive: false });

  window.addEventListener("resize", function () {
    stage.handleResize();
  }, false);

  $container.addClass("cv-loading");

  Promise.all(
    [`cavidb://${chain._id}.pdb`]
      .concat(...chain.pockets.map(it => `cavidb://${chain._id}/pockets/${it.pocket_id}.pqr`))
      .map(it => stage.loadFile(it))
  ).then(function (items) {
    $container.removeClass("cv-loading");

    const pdb = items[0];
    const pqrs = items.slice(1);

    pdb.addRepresentation("cartoon", { color: "bfactor" });
    pqrs.forEach((pqr, index) => {
      representationsSet.addPqr(index, pqr);
    });

    stage.mouseControls.remove('hoverPick');
    stage.mouseControls.add('hoverPick', (stage, pickingProxy) => {
      const tt = stage.tooltip;
      const sp = stage.getParameters();

      if (sp.tooltip && pickingProxy && pickingProxy.picker.structure.name.endsWith(".pqr")) {
        const mp = pickingProxy.mouse.position;
        tt.innerText = "Cavity " + pickingProxy.picker.structure.name.replace(".pqr", "");
        tt.style.bottom = (window.innerHeight - mp.y + 3) + 'px';
        tt.style.left = (mp.x + 3) + 'px';
        tt.style.display = 'block';
      } else {
        tt.style.display = 'none';
      }
    });

    stage.mouseControls.remove("scroll");
    stage.mouseControls.add("scroll", NGL.MouseActions.zoomScroll);
    stage.autoView();
  });
}

const RepresentationsSet = makeRepresentationsSet();
const leftRepresentationsSet = makeRepresentationsSet();
const rightRepresentationsSet = makeRepresentationsSet();

$(document).on("turbolinks:load", () => {
  const datasource = cavidb.currentChain ? "./" : "/chains/";
  NGL.DatasourceRegistry.add("cavidb", new NGL.StaticDatasource(datasource));
  initViewer('pdb-viewer', 'cv-pdb-container', cavidb.currentChain, RepresentationsSet);
  initViewer('pdb-viewer-left', 'cv-pdb-container-left', cavidb.leftChain, leftRepresentationsSet);
  initViewer('pdb-viewer-right', 'cv-pdb-container-right', cavidb.rightChain, rightRepresentationsSet);
});

export { RepresentationsSet, leftRepresentationsSet, rightRepresentationsSet }
